import { useTheme } from "next-themes";

/** Report detail surfaces — dark mode matches sidebar / dashboard cards. */
export const REPORTS_DETAIL_SURFACE_DARK = "var(--sidebar)";
export const REPORTS_DETAIL_MUTED_DARK = "var(--sidebar-foreground)";
export const REPORTS_DETAIL_BORDER_DARK = "var(--border)";

export const REPORTS_DETAIL_MUTED_TEXT_CLASS =
  "text-gray-500 dark:text-sidebar-foreground";

export const REPORTS_DETAIL_FIELD_DESC_CLASS =
  `font-[family-name:var(--font-primary)] text-sm font-normal ${REPORTS_DETAIL_MUTED_TEXT_CLASS}`;

export const REPORTS_DETAIL_FINDING_META_LABEL_CLASS =
  `font-[family-name:var(--font-primary)] text-xs font-normal ${REPORTS_DETAIL_MUTED_TEXT_CLASS}`;

/** Chakra color props shared by report detail tabs and embedded sections. */
export function useReportsDetailColors() {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return {
    isDark,
    subtleText: isDark ? REPORTS_DETAIL_MUTED_DARK : "gray.500",
    textColor: isDark ? REPORTS_DETAIL_MUTED_DARK : "gray.700",
    borderColor: isDark ? REPORTS_DETAIL_BORDER_DARK : "gray.200",
    panelBg: isDark ? REPORTS_DETAIL_SURFACE_DARK : "white",
    emptyPanelBg: isDark ? REPORTS_DETAIL_SURFACE_DARK : "gray.50",
    insetSurfaceBg: isDark ? REPORTS_DETAIL_SURFACE_DARK : "gray.50",
    evidencePreBorder: isDark ? REPORTS_DETAIL_BORDER_DARK : "gray.200",
  };
}
